import React from 'react';
import { Anchor } from 'Components';
import { Icons } from 'Assets';
import { Configs } from 'Constants';

interface Props {
  quantity: number;
  className?: string;
}

export const BasketHeaderIcon: React.FC<Props> = ({ quantity, className = '' }) => (
  <Anchor className={`inline-flex flex-col items-center ${className}`} href={Configs.basketUrl}>
    <div className="relative inline-flex items-center">
      <img src={Icons.Basket} alt="panier" className="h-6 w-6" />

      {quantity !== 0 && (
        <span className="font-bold absolute bg-red text-white rounded-full text-[10px] py-[3px] px-[5px] border-white border leading-[9px] top-3 -right-2 bg-clip-padding">
          {quantity}
        </span>
      )}
    </div>

    <span className="hidden md:inline md:font-bold md:text-xs pt-1">Panier</span>
  </Anchor>
);
